import { render, staticRenderFns } from "./form-repository-config.vue?vue&type=template&id=52b105dd&"
import script from "./form-repository-config.vue?vue&type=script&lang=js&"
export * from "./form-repository-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports